import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { mdiAlertCircleOutline, mdiCheck, mdiInformationOutline, mdiClose } from '@mdi/js';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import * as THEME_BORDER_RADIUS from '@upgrade/themes/constants/border-radius';
import IconButton from '../IconButton';
import Icon from '../Icon';
import { AlertTitle, AlertContainer, IconContainer, ContentContainer } from './styles';
const SEVERITIES = ['error', 'warning', 'info', 'emphasis', 'success'];
const BORDER_RADIUS = Object.keys(THEME_BORDER_RADIUS);
const Alert = /*#__PURE__*/React.forwardRef(({
  title,
  severity = 'info',
  children,
  onClose,
  icon,
  displayBorders = true,
  borderRadius = 'SMALL',
  padded = true,
  ...props
}, ref) => {
  const theme = useTheme();
  const config = {
    error: {
      icon: mdiAlertCircleOutline,
      iconColor: theme.palette.semanticError,
      borderColor: theme.palette.semanticError
    },
    warning: {
      icon: mdiAlertCircleOutline,
      iconColor: theme.palette.semanticWarning,
      borderColor: theme.palette.semanticWarning
    },
    info: {
      icon: mdiInformationOutline,
      iconColor: theme.palette.semanticInfoText,
      borderColor: theme.palette.semanticInfo
    },
    emphasis: {
      icon: mdiInformationOutline,
      iconColor: theme.palette.semanticInfoStrong,
      borderColor: theme.palette.semanticInfoStrong
    },
    success: {
      icon: mdiCheck,
      iconColor: theme.palette.semanticPositive,
      borderColor: theme.palette.semanticPositive
    }
  };
  return /*#__PURE__*/React.createElement(AlertContainer, _extends({
    ref: ref,
    "aria-live": severity === 'error' ? 'assertive' : 'polite',
    $color: displayBorders ? config[severity].borderColor : 'transparent',
    $borderRadius: borderRadius,
    $padded: padded
  }, props), /*#__PURE__*/React.createElement(IconContainer, null, icon || /*#__PURE__*/React.createElement(Icon, {
    icon: config[severity].icon,
    color: config[severity].iconColor,
    size: "1.5rem",
    display: "block"
  })), /*#__PURE__*/React.createElement(ContentContainer, null, title ? /*#__PURE__*/React.createElement(AlertTitle, null, title) : null, children), onClose && /*#__PURE__*/React.createElement(IconButton, {
    icon: mdiClose,
    size: "1rem",
    onClick: onClose,
    label: "Close"
  }));
});
Alert.propTypes = {
  severity: PropTypes.oneOf(SEVERITIES),
  title: PropTypes.node,
  children: PropTypes.node,
  onClose: PropTypes.func,
  displayBorders: PropTypes.bool,
  borderRadius: PropTypes.oneOf(BORDER_RADIUS),
  padded: PropTypes.bool
};
export { AlertTitle, SEVERITIES, BORDER_RADIUS };
export default Alert;
//# sourceMappingURL=index.js.map